import { c as _c } from "react/compiler-runtime";
import { LinkComponent } from '@/components/ui/link-component';
import type { SearchResultCard as SearchResultCardData } from '@/features/payload-cms/components/search/search-results';
import type { Locale } from '@/types/types';
import type React from 'react';
const SearchResultCard: React.FC<{
  result: SearchResultCardData;
  locale: Locale;
}> = t0 => {
  const $ = _c(18);
  const {
    result,
    locale
  } = t0;
  const t1 = result.url;
  let t2;
  if ($[0] !== locale || $[1] !== result.createdAt) {
    t2 = new Date(result.createdAt).toLocaleDateString(locale, {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
      timeZone: "Europe/Zurich"
    });
    $[0] = locale;
    $[1] = result.createdAt;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <span className="font-body text-[12px] font-bold text-gray-500">{t2}</span>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== result.title) {
    t4 = <h4 className="font-heading text-conveniat-green mb-6 line-clamp-3 min-h-[1.5rem] text-base font-extrabold text-ellipsis">{result.title}</h4>;
    $[5] = result.title;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = <div>{t3}{t4}</div>;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== result.excerpt) {
    t6 = <div><p className="text-sm text-gray-500">{result.excerpt}</p></div>;
    $[10] = result.excerpt;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t5 || $[13] !== t6) {
    t7 = <div className="flex basis-1 flex-col rounded-md border-2 border-gray-200 bg-white p-6 transition duration-200 hover:shadow-md lg:max-w-96">{t5}{t6}</div>;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== result.url || $[16] !== t7) {
    t8 = <LinkComponent href={t1}>{t7}</LinkComponent>;
    $[15] = result.url;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  return t8;
};
export default SearchResultCard;